import type { FetchQueryOptions } from '@tanstack/react-query';

import type {
  GreenhouseOfficeTreeData,
  JobBoardName,
} from '@/app/[locale]/careers/_components/CareersGreenhouseJobBoard/types';

import { JOB_BOARD_NAME } from '../_components/CareersGreenhouseJobBoard/consts';

const BASE_URL = 'https://boards-api.greenhouse.io/v1/boards';

const getGreenhouseOfficeTree = async (
  jobBoardName: JobBoardName,
): Promise<GreenhouseOfficeTreeData> => {
  const response = await fetch(
    `${BASE_URL}/${jobBoardName}/offices?render_as=tree`,
  );

  if (!response.ok) {
    throw new Error('Error fetching office tree from Greenhouse API');
  }

  return response.json() as Promise<GreenhouseOfficeTreeData>;
};

export const getGreenhouseOfficeTreeWithQueryKey = (
  jobBoardName: JobBoardName = JOB_BOARD_NAME,
): FetchQueryOptions<
  GreenhouseOfficeTreeData,
  Error,
  GreenhouseOfficeTreeData,
  string[],
  never
> => ({
  queryKey: ['officeTree', jobBoardName],
  queryFn: () => getGreenhouseOfficeTree(jobBoardName),
});
